import React from "react";
import WishlistButton from "./WishlistButton";
function Footwear(){
    return <div className="Kids">

    <div className ="mencard">
 <div className="catalog-section-title"> <h1>Mens Foot Wear</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/EEZAY MAXOUT Flip Flops.jpeg"} alt="" />
</div>
<div className="card-header">
<h6>EEZAY MAXOUT Flip Flops</h6>
<h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Double Soft Comfortable Grass Eva Rubber Healthy Slippers For Men's And Boy's Flip Flops.jpeg"} alt="" /></div>
<div className="card-header"><h6>Double Soft Comfortable Grass Eva Rubber Healthy Slippers For Men's And Boy's Flip Flops</h6><h4> ₹349 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Casual Slippers Flip Flops.jpeg"} alt="" /></div>
<div className="card-header"><h6>Casual Slippers Flip Flops</h6><h4> ₹249 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Puma Flip Flops.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Puma Flip Flops</h6><h4> ₹1,099 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Men's Smiley Flip Flop Slides.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men's Smiley Flip Flop Slides</h6><h4> ₹359 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Men Synthetic Leather Chappal (Camel) Slippers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men's Smiley Flip Flop Slides</h6><h4> ₹359 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Men Synthetic Leather Chappal (Beige) Slides.jpeg"} alt="" /></div>
<div className="card-header"><h6>Men Synthetic Leather Chappal (Beige) Slides</h6><h4> ₹359 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Sparx Slippers.jpeg"} alt="" /></div>
<div className="card-header"><h6>Sparx Slippers</h6><h4> ₹444 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Puma Slippers.jpeg"}alt="" /></div>
<div className="card-header"><h6>Puma Slippers</h6><h4> ₹399 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/SFG-204 Flip Flops.jpeg"} alt="" /></div>
<div className="card-header"><h6>Sparx SFG-204 Flip Flops</h6><h4> ₹267 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/SFG-204 FlipFlops.jpeg"} alt="" /></div>
<div className="card-header"><h6>SFG-204 FlipFlops</h6><h4> ₹267 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="footimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Pery Pao Slides.jpeg"} alt="" /></div>
<div className="card-header"><h6>Pery Pao Slides</h6><h4> ₹233 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>


 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Mens Casual Shoes</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/FELTON Motorsport Shoes For Men  (Black).jpeg"} alt="" /></div>
<div className="card-header"><h6>FELTON Motorsport Shoes For Men  (Black)</h6><h4> ₹298 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/OFF CUT Basketball Shoes For Men  (Blue).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Fila OFF CUT Basketball Shoes For Men  (Blue)</h6><h4> ₹2,219 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/HAMLINO Sneakers For Men  (Black).jpeg"} alt="" /></div>
<div className="card-header"><h6>HAMLINO Sneakers For Men  (Black)</h6><h4> ₹2,169 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/KICK HC Football Shoes For Men  (Grey).jpeg"} alt="" /></div>
<div className="card-header"><h6>KICK HC Football Shoes For Men  (Grey)</h6><h4> ₹1,528 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Sneakers For Men  (Green).jpeg"} alt="" /></div>
<div className="card-header"><h6>Sneakers For Men  (Green)</h6><h4> ₹2,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Casual Shoe For Men  (Olive).jpeg"} alt="" /></div>
<div className="card-header"><h6>Casual Shoe For Men  (Olive)</h6><h4> ₹3,395 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Sneakers For Men  (Tan).jpeg"} alt="" /></div>
<div className="card-header"><h6>Sneakers For Men  (Tan)</h6><h4> ₹1,049 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Sneakers For Men  (Navy).jpeg"} alt="" /></div>
<div className="card-header"><h6>Sneakers For Men  (Navy)</h6><h4> ₹2,399 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>


 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Womens Foot Wear</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Pink Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Pink Flats Sandal</h6><h4> ₹2,169 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Orange Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Orange Flats Sandal</h6><h4> ₹249 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Pink Flats Sandals.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Women Pink Flats Sandals</h6><h4> ₹248 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Brown Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Brown Flats Sandal</h6><h4> ₹299 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Black Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Black Flats Sandal</h6><h4> ₹238 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Beige FlatsSandal.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Women Beige Flats Sandal</h6><h4> ₹321 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Multicolor Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Multicolor Flats Sandal</h6><h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Multicolor FlatsSandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Multicolor FlatsSandal</h6><h4> ₹351 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Beige Flats Sandal.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Women Beige Flats Sandal</h6><h4> ₹699 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Gold Flats Sandal.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Women Gold Flats Sandal</h6><h4> ₹378 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Multicolor Flats Sandals.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Multicolor Flats Sandals</h6><h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Brown Flats Sandals.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Women Brown Flats Sandal</h6><h4> ₹379 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women BlackFlats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women BlackFlats Sandal</h6><h4> ₹399 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Beige Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Beige Flats Sandal</h6><h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 
 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/Women Blue Flats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Blue Flats Sanda</h6><h4> ₹427 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/footwearimages/WomenBlackFlats Sandal.jpeg"} alt="" /></div>
<div className="card-header"><h6>Women Black Flats Sandal</h6><h4> ₹449 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 </div>
 </div>


</div>
}
export default Footwear;